import { render, staticRenderFns } from "./DownloadGames.vue?vue&type=template&id=637d16fd&"
import script from "./DownloadGames.vue?vue&type=script&lang=js&"
export * from "./DownloadGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637d16fd')) {
      api.createRecord('637d16fd', component.options)
    } else {
      api.reload('637d16fd', component.options)
    }
    module.hot.accept("./DownloadGames.vue?vue&type=template&id=637d16fd&", function () {
      api.rerender('637d16fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/DownloadGames.vue"
export default component.exports